import styled, { css } from 'styled-components';
import { ANIMATION_DURATION } from '@optimus-web/common';

export interface DecorationImageElementProps {
    imageSrc?: string;
    showOverlay?: boolean;
}

export const DecorationImageElement = styled.div<DecorationImageElementProps>`
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url('${(props) => props.imageSrc}');
    opacity: ${(props) => (props.imageSrc ? 1 : 0)};
    transition: ${ANIMATION_DURATION.default}ms opacity ease-out;

    ${(props) =>
        props.showOverlay &&
        css`
            &::after {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.2);
                top: 0;
                left: 0;
            }
        `}
`;
